import React from 'react';
import { IPerson } from '../../../../../../../Interfaces/IPerson';
import { Box, Divider, Grid, Typography } from '@mui/material';
import { ICompany } from '../../../../../../../Interfaces/ICompany';

interface IProps {
  beneficiary: IPerson | ICompany | null;
}

export const MortgagePersonSummary: React.FC<IProps> = ({ beneficiary }) => {
  return (
    <>
      {beneficiary && (
        <>
          <Box ml={5} mt={2}>
            <Typography variant='h6' mb={2}>
              Begünstigter
            </Typography>
            <Grid container spacing={2} ml={8}>
              {beneficiary && (
                <>
                  <Grid item sm={4}>
                    <b>Unternehmen oder Privatperson?</b>
                  </Grid>
                  <Grid item sm={8}>
                    {'idCompany' in beneficiary
                      ? 'Unternehmen'
                      : 'Privatperson'}
                  </Grid>
                </>
              )}

              {'idCompany' in beneficiary && beneficiary.Company.length > 0 && (
                <>
                  <Grid item sm={4}>
                    <b>Firmenname:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {beneficiary.Company}
                  </Grid>
                </>
              )}

              {'idPerson' in beneficiary &&
                beneficiary.FirstName.length > 0 && (
                  <>
                    <Grid item sm={4}>
                      <b>Vorname:</b>
                    </Grid>
                    <Grid item sm={8}>
                      {beneficiary.FirstName}
                    </Grid>
                  </>
                )}

              {'idPerson' in beneficiary && beneficiary.LastName.length > 0 && (
                <>
                  <Grid item sm={4}>
                    <b>Nachname:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {beneficiary.LastName}
                  </Grid>
                </>
              )}

              {beneficiary.Email && beneficiary.Email.length > 0 && (
                <>
                  <Grid item sm={4}>
                    <b>Email:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {beneficiary.Email}
                  </Grid>
                </>
              )}

              {beneficiary.PhoneNumber &&
                beneficiary.PhoneNumber.length > 0 && (
                  <>
                    <Grid item sm={4}>
                      <b>Telefon:</b>
                    </Grid>
                    <Grid item sm={8}>
                      {beneficiary.PhoneNumber}
                    </Grid>
                  </>
                )}

              {beneficiary.Street && beneficiary.Street.length > 0 && (
                <>
                  <Grid item sm={4}>
                    <b>Straße:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {beneficiary.Street}
                  </Grid>
                </>
              )}

              {beneficiary.StreetNr && beneficiary.StreetNr.length > 0 && (
                <>
                  <Grid item sm={4}>
                    <b>Hausnummer:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {beneficiary.StreetNr}
                  </Grid>
                </>
              )}

              {beneficiary.Postcode && beneficiary.Postcode.length > 0 && (
                <>
                  <Grid item sm={4}>
                    <b>Postleitzahl:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {beneficiary.Postcode}
                  </Grid>
                </>
              )}

              {beneficiary.City && beneficiary.City.length > 0 && (
                <>
                  <Grid item sm={4}>
                    <b>Ort:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {beneficiary.City}
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ mt: 2, mr: 5, borderColor: 'text.primary' }} />
            </Grid>
          </Box>
        </>
      )}
    </>
  );
};
